import { styled } from 'baseui'

export const Badge = styled('span', ({ $theme }) => ({
  position: 'absolute',
  right: 0,
  top: '50%',
  transform: 'translateY(-50%)',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '1.25rem',
  height: '1.25rem',
  borderRadius: '50%',
  backgroundColor: $theme.colors.white,
  border: `1px solid ${$theme.colors.warningText}`,
  color: $theme.colors.warningText,
  lineHeight: 0,
}))
